import { createFileRoute } from '@tanstack/react-router'
import { zodValidator } from '@tanstack/zod-adapter'
import { z } from 'zod'

import { cableQueries } from 'lib/queries'
import { requireGlobalUser } from 'lib/routeGuards'
import { getUIVersion } from 'lib/uiVersion'

import Cable from 'pages/Cable'
import CableClassic from 'pages/Cable/Cable.classic'

const IS_CLASSIC_UI = getUIVersion() === 'classic'

const cableSearchSchema = z.object({
  calibration: z.string().optional(),
})

export const Route = createFileRoute('/_auth/cables/$id')({
  component: IS_CLASSIC_UI ? CableClassic : Cable,
  beforeLoad: requireGlobalUser,
  validateSearch: zodValidator(cableSearchSchema),
  loader: ({ context: { queryClient }, params: { id } }) => {
    const isExistingCable =
      (id.startsWith('sn') && !isNaN(id.replace('sn', '') as any)) ||
      !isNaN(id as any)

    if (!isExistingCable) return

    void queryClient.prefetchQuery(cableQueries.detail(id))
  },
})
